<div class="modal">
  <i class="fal fa-times modal__close"
     (click)="close()"></i>

  <h1>Connection Matching</h1>
  <p class="mb-0050">Only include entities with...</p>
  <mat-radio-group class="col__"
                   [(ngModel)]="hasConnections">
    <mat-radio-button class="col__ mb-0050"
                      [value]="false">
      <span class="txt-16 d-block"
            [ngClass]="{'txt-fw-600': !hasConnections}">
        Matching connections
      </span>
      <span class="txt-13 color--gray--005">
        Having connections to a specific entity and/or connections with specific responses
      </span>
    </mat-radio-button>
    <mat-radio-button class="col__ mb-0050"
                      [value]="true">
      <span class="txt-16 d-block"
            [ngClass]="{'txt-fw-600': hasConnections}">
        Any connections
      </span>
      <span class="txt-13 color--gray--005">
        Having any connections at all
      </span>
    </mat-radio-button>
  </mat-radio-group>
  <p class="mb-0050">Optionally specify the connection type...</p>
  <mat-form-field class="col__">
    <mat-label>Connection Type</mat-label>
    <mat-select [(ngModel)]="entityConnectionTypeId">
      <mat-select-trigger>
        <app-connection-type-name [connectionType]="selectedEntityConnectionType">
        </app-connection-type-name>
      </mat-select-trigger>
      <mat-option *ngFor="let option of entityConnectionTypes"
                  [value]="option.id">
        <app-connection-type-name [connectionType]="option">
        </app-connection-type-name>
      </mat-option>
    </mat-select>
    <button matSuffix
            mat-icon-button
            aria-label="Clear Connection Type"
            *ngIf="entityConnectionTypeId"
            (click)="entityConnectionTypeId = null">
      <mat-icon fontSet="fal"
                fontIcon="fa-times"></mat-icon>
    </button>
  </mat-form-field>

  <div class="col__ mt-0075 flex flexJustify-end">
    <button class="btn"
            type="button"
            (click)="onDone()">Done</button>
  </div>
</div>
